export const cardCourses = [
  {
    id: "card1",
    title: "Hargeisa",
    description:
      "Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat",
    price: "10.00",
  },
  {
    id: "card2",
    img: "blog2.png",
    title: "Borama",
    date: "12 Jun 2019",
    description:
      "Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat",
    rate: "star.png",
    rateEmpty: "starEmpty.png",
    price: "10.00",
    oldprice: "50.00",
  },
  {
    id: "card3",
    img: "blog3.png",
    title: "Gebilay",
    date: "12 Jun 2019",
    description:
      "Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat",
    rate: "star.png",
    rateEmpty: "starEmpty.png",
    price: "10.00",
    oldprice: "50.00",
  },
];
